import axios from 'axios';
import {
  V1_SUMMARY,
  V1_EXPORT_SUMMARY,
  V1_SUPPLIER,
  V1_EXPORT_SUPPLIER,
  V1_SUPPLIER_BY_ID,
  V1_ADJUSTMENTS_NEW,
  V1_EXPORT_ADJUSTMENT,
} from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getSummary(params) {
  return axios.get(V1_SUMMARY, { params, withCredentials: true }).catch(reject);
}

export function getExportSummary(params) {
  return axios
    .get(V1_EXPORT_SUMMARY, { params, withCredentials: true })
    .catch(reject);
}

export function getSuppliers(params) {
  return axios
    .get(V1_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function getExportSupplier(params) {
  return axios
    .get(V1_EXPORT_SUPPLIER, { params, withCredentials: true })
    .catch(reject);
}

export function deleteSupplier(id, params) {
  return axios
    .delete(V1_SUPPLIER_BY_ID(id), { params, withCredentials: true })
    .catch(reject);
}

export function putSupplier(id, data, params) {
  return axios
    .put(V1_SUPPLIER_BY_ID(id), data, { params, withCredentials: true })
    .catch(reject);
}

export function postSuppliers(data, params) {
  return axios
    .post(V1_SUPPLIER, data, { params, withCredentials: true })
    .catch(reject);
}

export function getAdjustments(params) {
  return axios
    .get(V1_ADJUSTMENTS_NEW, { params, withCredentials: true })
    .catch(reject);
}

export function getExportAdjustment(params) {
  return axios
    .get(V1_EXPORT_ADJUSTMENT, { params, withCredentials: true })
    .catch(reject);
}
